import React, { useState } from 'react';
import { generateTimeString } from '../../../Utils/helper';
import { convertPrice } from '../../../Utils/ForeignUtils';
import Cookies from 'js-cookie';
import Description from './Description';
import { CopyButton, OfferCode, UseCode } from './styled';

function OfferNewDesignInner(props) {
  const {
    data,
    productPrice,
    eventHandler,
    index,
    countShownOffers,
    showButton,
    showNewOfferTitle,
    userType,
  } = props;

  const { day, month, elapsedDays } = generateTimeString(data?.expire_date);

  const [gesture, setGesture] = useState();

  const onCopyCoupon = (data) => {
    if (!Cookies.get('coupon_code')) {
      Cookies.set('coupon_code', data);
    }
    window?.navigator.clipboard.writeText(`${data}`);
    eventHandler('copyCode');
  };

  const hideShowBorder = () => {
    if (showButton()) {
      return '';
    } else {
      return 'hideBorder';
    }
  };

  const clickFeedback = () => {
    setGesture(true);
    setTimeout(() => {
      setGesture(false);
    }, 120);
  };

  const { symbol, price } = convertPrice(data?.offerPrice);
  return (
    <li
      className={
        index < countShownOffers
          ? `li show animate ${hideShowBorder()}`
          : `li  animate ${hideShowBorder()}`
      }
      key={index}
    >
      <div
        onClick={() => {
          onCopyCoupon(data?.code);
          clickFeedback();
        }}
        className="dropdown_option"
        style={{ opacity: gesture ? 0.4 : 1 }}
      >
        <div
          onClick={() => {
            eventHandler(data);
            clickFeedback();
          }}
        >
          <div className="offer_name_heading">
            <div>
              {data?.offerPrice &&
              data?.offerPrice != undefined &&
              productPrice > data?.cart_min_amount ? (
                showNewOfferTitle ? (
                  <>
                    <strong>
                      {data?.name} + 5% OFF on <br />
                      Online Payment
                    </strong>
                  </>
                ) : (
                  <>
                    Get it for{' '}
                    <strong>
                      {symbol}
                      {price}
                    </strong>
                  </>
                )
              ) : (
                <strong>{data?.name}</strong>
              )}
            </div>

            {elapsedDays < 10 ? (
              <p className="valid_till">
                Valid Till:{' '}
                <b>
                  {day} {month}
                </b>
              </p>
            ) : null}
          </div>
          <Description data={data} />
        </div>
        <OfferCode>
          <UseCode
            onClick={() => {
              eventHandler(data);
              clickFeedback();
            }}
          >
            <span>Use Code</span>
            <strong>{data?.code}</strong>
          </UseCode>
          <CopyButton>Copy code</CopyButton>
        </OfferCode>
      </div>
    </li>
  );
}

export default OfferNewDesignInner;
